import React, { useEffect, useRef, useState } from "react";

const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Work", href: "#portfolio" },
  { label: "Media", href: "#media" },
  { label: "Contact", href: "#contact" },
];

const HERO_LINKS = [
  { label: "GitHub", href: "https://github.com/PatrickCleary" },
  { label: "Twitter", href: "https://x.com/PatrickDCleary" },
  { label: "LinkedIn", href: "https://www.linkedin.com/in/pdcleary/" },
  { label: "Substack", href: "https://patrickcleary1.substack.com/" },
];

export const Hero = () => {
  const [showScrollHint, setShowScrollHint] = useState(false);
  const hasScrolled = useRef(false);

  useEffect(() => {
    const handleScroll = () => {
      hasScrolled.current = true;
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!hasScrolled.current) setShowScrollHint(true);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <nav className="site-nav">
        <a href="#" className="nav-logo">
          PC
        </a>
        <ul className="nav-links">
          {NAV_LINKS.map(({ label, href }) => (
            <li key={label}>
              <a href={href}>{label}</a>
            </li>
          ))}
        </ul>
      </nav>

      <section id="hero" className="hero-section">
        <div className="hero-grid-overlay" />

        <div className="hero-number">Portfolio — 2026</div>

        <h1 className="hero-name">
          Patrick
          <img className="outline-svg" src="/Cleary.svg" alt="Cleary" />
        </h1>

        <p className="hero-tagline">
          Working at the intersection of <em>technology, design,</em> and{" "}
          <em>urban planning</em> — building tools that make the built
          environment easier to understand.
        </p>

        <div className="hero-links">
          {HERO_LINKS.map(({ label, href }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {label}
            </a>
          ))}
        </div>

        <div className={`scroll-hint${showScrollHint ? " visible" : ""}`}>
          Scroll
        </div>
      </section>
    </>
  );
};
